import axios from 'axios';

interface PreviewResponse {
  error?: string;
  image: string;
  success: boolean;
}

interface UpdateImageResponse {
  success: boolean;
  picture_url: string;
}

export function postPreviewImage(accountId: number, image?: string): Promise<PreviewResponse> {
  const postData: {
    action: 'preview_logo';
    image?: string;
  } = {
    action: 'preview_logo',
  };

  if (image) {
    postData.image = image;
  }

  return axios.post(`/api/v1/accounts/${accountId}`, postData).then((response) => response.data);
}

export function putAccountUpdate(
  accountId: number,
  accountType: string,
  image?: string,
): Promise<UpdateImageResponse> {
  const putData: {
    payment_method_nonce: null;
    type: string;
    image?: string;
  } = {
    payment_method_nonce: null,
    type: accountType,
  };

  if (image) {
    putData.image = image;
  }

  return axios.put(`/api/v1/accounts/${accountId}`, putData).then((response) => response.data);
}
